import { Component, Inject } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DistanceInfo } from '@core/models/domains/hotel';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'iho-isActive-modal',
  standalone: true,
  imports: [CommonModule, MatRadioModule, MatButtonModule,RouterLink],
  templateUrl: './isActive-modal.component.html',
  styleUrls: ['./isActive-modal.component.scss'],
})
export class isActiveModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<isActiveModalComponent>
  ) {
  }


}
